import { BellOutlined, CaretDownOutlined, CommentOutlined, DatabaseOutlined, FileAddOutlined, FileOutlined, GlobalOutlined, HomeOutlined, LineChartOutlined, ProfileOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Badge, Flex, Layout, Menu, Space, theme, Typography } from 'antd';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Footer from "../components/Footer"
import { getScannerType } from "../utils/other"
const { Header, Content, Sider } = Layout;
const { Text, Title } = Typography
function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}
const items = [
  getItem('Home', "/", <HomeOutlined />),
  getItem('Item', 'item', <DatabaseOutlined />),
  getItem('Order', 'order', <CommentOutlined />),
  getItem('Profile', 'profile', <UserOutlined />),
  getItem('Users', '', <TeamOutlined />, [
    getItem('Customer', 'customer'),
    getItem('Delivery Partner', 'delivery'), 
    getItem('Guest', 'guest'), 
  ]),
];


export default function () {
  var device = getScannerType()
  const { userDetails } = useSelector(s => s.user)
  const [width] = useState(window.innerWidth);
  const [collapsed, setCollapsed] = useState(width < 700);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const navigate = useNavigate()
  const location = useLocation()


  const handleClickSideBarMenu = e => {
    if (device !== "desktop") {
      setCollapsed(true)
    }
    navigate(e.key)
  }

  return (
    <Layout >
      <Sider
        theme='light'
        collapsible
        style={{ position: "fixed", height: "100vh",zIndex:9}}
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)} >

        <Flex justify='center' style={{ marginTop: "15px" }}>
          {!collapsed
            ? <img src="/image/logo_trans.png" height={70} alt="error" />
            : <img src="/image/logo_trans.png" height={50} alt="error" />}
        </Flex>

        <Menu
          theme="light"
          defaultSelectedKeys={location.pathname.replace("/", "") || "/"} 
          onClick={handleClickSideBarMenu}
          items={items} />

      </Sider>
      <Layout style={{
        transform: `${!collapsed && device !== "desktop" ? "perspective(600px) rotateY(20deg) scale(.8) translateX(120px)" : ""}`,
        marginLeft: `${!collapsed && device === "desktop" ? "120px" : ""}`,
        background: colorBgContainer,
        transition: ".3s"
      }}>
        <Flex style={{
          padding: "15px",
          background: colorBgContainer,
        }} justify="space-between" align='center'>

          <Title level={4} style={{ textTransform: "capitalize", marginLeft: "80px" }}>{location.pathname.replace("/", "") || "Admin Dashboard"}</Title>

          <Flex gap={20}>
            <Badge size='small' count={2}>
              <BellOutlined style={{ fontSize: '22px', color: '#08c' }} />
            </Badge>
            <Avatar src={userDetails.photo} onClick={_ => navigate("/profile")} style={{ cursor: "pointer", backgroundColor: '#1677ff48', color: "#000", marginTop: "-5px" }} icon={<UserOutlined />} />
          </Flex>

        </Flex>
        <Content>
          <div
            style={{
              margin: "0 15px 0 95px",
              minHeight: "90vh",
              background: colorBgContainer,
            }}
          >
            <Outlet />
          </div>
        </Content>


        <Footer />
      </Layout>
    </Layout>
  );
}; 